import {useState} from "react";
import MainLayout from "../components/layouts/MainLayout";
import {getCookiePreferences} from "../helpers/cookies";
import localized from "../locale/locales";
import {useRouter} from "next/router";
import CtaBanner from "../components/CtaBanner";
import SectionConceptHeader from "../components/sections/SectionConceptHeader";
import SectionConceptIntro from "../components/sections/SectionConceptIntro";
import SectionFeatures from "../components/sections/SectionFeatures";
import SectionPersonBlock from "../components/sections/SectionPersonBlock";
import Video from "../components/Video";
import Container from "../components/Container";
import Gallery from "../components/Gallery";
import Lightbox from "../components/Lightbox";
import bannerImage from '../public/img/cta_banner.png';

// Features icons
import iconDumbbell from '../public/img/icons/dumbbell.png';
import iconBurn from '../public/img/icons/burn.png';
import iconIntensity from '../public/img/icons/intensity.png';
import iconLightning from '../public/img/icons/lightning.png';
import iconGraph from '../public/img/icons/graph.png';
import iconCommunity from '../public/img/icons/community.png';

// Gallery images
import imageGallery01 from '../public/img/gallery/next-battle/1.jpg';
import imageGallery02 from '../public/img/gallery/next-battle/2.jpg';
import imageGallery03 from '../public/img/gallery/next-battle/3.jpg';
import {getLocationBookClassLink} from "../helpers/locations";


const icons = [
    iconDumbbell,
    iconBurn,
    iconIntensity,
    iconLightning,
    iconGraph,
    iconCommunity
]

export default function NextBattle({hasCookiePreferences, cookiePreferences}) {
    const {locale} = useRouter();
    const {nextBattle: lang} = localized[locale];

    const [hiddenNav, setHiddenNav] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [activeVideo, setActiveVideo] = useState(null);

    return (
        <MainLayout hasCookiePreferences={hasCookiePreferences}
                    cookiePreferences={cookiePreferences}
                    hiddenNav={hiddenNav}
                    footerTheme="light"
                    title={lang.og.title}
            // description={lang.og.description}
            // image={`https://nextmove.cz/img/og/${locale}_og-image_next-battle.png`}
        >
            <Lightbox
                active={showPopup}
                onClose={() => {
                    setShowPopup(false);
                    setActiveVideo(null);
                    setHiddenNav(false);
                }}
            >
                <Video url={activeVideo} active={showPopup}/>
            </Lightbox>


            <SectionConceptHeader
                mobileVideo="/videos/hero/next_battle_mobile.mp4"
                tabletVideo="/videos/hero/next_battle_tablet.mp4"
                desktopVideo="/videos/hero/next_battle_desktop.mp4"
                align="bottom"
                title={lang.header.title}
                body={lang.header.body}
                className="max-w-[430px] pb-20"
            />

            <SectionConceptIntro
                title={lang.intro.title}
                body={lang.intro.body}
                titleClassName="max-w-[26ch]"
                cta={{
                    href: getLocationBookClassLink('karlin'),
                    target: '_blank',
                    rel: 'noreferrer nofollow',
                    label: lang.intro.cta
                }}
            />

            <div style={{
                background: 'linear-gradient(to bottom,rgba(255,255,255,1) 0%,rgba(255,255,255,1) 50%,rgba(0,0,0,1) 50%,rgba(0,0,0,1) 100%)'
            }}>
                <Container fullMobile={true}>
                    <Gallery images={[
                        imageGallery01,
                        imageGallery02,
                        imageGallery03
                    ]}/>
                </Container>
            </div>

            <SectionFeatures
                items={lang.features}
                icons={icons}
                className="pt-24 md:pb-24"
            />

            <div className="pt-16 md:pt-0">
                <SectionPersonBlock
                    video={'/videos/trainers/katerina_baudysova.mp4'}
                    name={lang.trainerBlock.trainer.name}
                    description={lang.trainerBlock.trainer.description}
                    title={lang.trainerBlock.title}
                    body={lang.trainerBlock.body}
                />
            </div>

            <CtaBanner
                title={lang.banner.title}
                body={lang.banner.body}
                cta={{
                    href: getLocationBookClassLink('karlin'),
                    target: '_blank',
                    rel: 'noreferrer nofollow',
                    label: lang.banner.cta
                }}
                background={bannerImage}
            />
        </MainLayout>
    )
}


export async function getServerSideProps({req, res}) {
    const cookiePreferences = getCookiePreferences(req);

    return {
        props: {
            ...cookiePreferences
        }
    }
}
